import { render, staticRenderFns } from "./SessionVideo.vue?vue&type=template&id=47cb0a74&"
import script from "./SessionVideo.vue?vue&type=script&lang=js&"
export * from "./SessionVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports